<div class="-business-type" [ngClass]="meta.type === 'marketplaces' ? '-marketplaces' : ''">
  @if (body) {
  <content-viewer [content]="body" (docRendered)="handleDocRendered($event)"> </content-viewer>
  }
</div>
